import { useQuery } from "@tanstack/react-query";
import { getMigrationUploads } from "@/shared/actions/campanas/migracion.actions";

type CampaignType = "MIGRATION" | "FIDELIZATION";

export const useMigrationUploads = (
  page: number,
  size: number,
  campaignType: CampaignType
) => {
  const query = useQuery({
    queryKey: ["migration-uploads", page, size, campaignType],
    queryFn: () => getMigrationUploads(page, size, campaignType),
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    loading: query.isLoading,
    refetch: query.refetch,
  };
};